import React from 'react';
import PropTypes from 'prop-types';

const TimelineToolbar = ({ options, value, onChange, disabled }) => (
    <div className="timeline-toolbar" role="group" aria-label="Timeline range selector">
        {options.map((option) => {
            const isActive = option.value === value;
            return (
                <button
                    key={option.value}
                    type="button"
                    className={[
                        'timeline-toolbar__button',
                        isActive ? 'timeline-toolbar__button--active' : '',
                    ].join(' ').trim()}
                    onClick={() => onChange(option.value)}
                    disabled={disabled || option.disabled}
                    aria-pressed={isActive}
                >
                    {option.label}
                </button>
            );
        })}
    </div>
);

TimelineToolbar.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
    })).isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

TimelineToolbar.defaultProps = {
    disabled: false,
};

export default TimelineToolbar;
